import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class TabMenu extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tab-menu',
            className,
        ];
    }

}

TabMenu.propTypes = propTypes;

TabMenu.defaultProps = defaultProps;

export default TabMenu;
